import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

/*
  args
    - value
    - onChange(value)
*/

export default class extends Component {
  @action
  handleChange(e) {
    this.args.onChange?.(e.target.value);
  }

  @action
  templateDidInsert(e) {
    this.element = e;
    this.setHeight();
  }

  // https://gomakethings.com/automatically-expand-a-textarea-as-the-user-types-using-vanilla-javascript/
  @action
  setHeight() {
    this.element.style.height = 'inherit';

    // Get the computed styles for the element
    let computed = window.getComputedStyle(this.element);

    // Calculate the height
    let height =
      parseInt(computed.getPropertyValue('border-top-width'), 10) +
      parseInt(computed.getPropertyValue('padding-top'), 10) +
      this.element.scrollHeight +
      parseInt(computed.getPropertyValue('padding-bottom'), 10) +
      parseInt(computed.getPropertyValue('border-bottom-width'), 10);

    this.element.style.height = `${height}px`;
  }
}
